import type { BadgeProps } from '@app/components/ui/badge'
import type { EmirStatus } from './api'

const numberFormat = new Intl.NumberFormat('tr-TR')
const quantityFormat = new Intl.NumberFormat('tr-TR', { maximumFractionDigits: 3 })

export const formatNumber = (value: number): string => numberFormat.format(value)
export const formatQuantity = (value: number | null): string =>
  value == null ? '—' : quantityFormat.format(value)

/**
 * API dates arrive as `YYYY-MM-DDTHH:MM:SS`, WITHOUT a timezone suffix (Korgun
 * keeps factory wall-clock time in `timestamp without time zone`). Converting
 * to `Date` risks a shift to the browser's timezone, so the string is split
 * directly instead — same pattern as the stock/production modules.
 */
export function formatDate(iso: string | null): string {
  if (!iso) return '—'
  const [year, month, day] = iso.slice(0, 10).split('-')
  if (!year || !month || !day) return '—'
  return `${day}.${month}.${year}`
}

export interface StatusView {
  label: string
  tone: BadgeProps['tone']
}

/**
 * `Urtx_Emir.Durum` was decoded against the mirror: every 'X' emir has a
 * finished (fin) row, every 'B' emir only has a waiting row, and empty ones
 * have no production row at all.
 */
export const EMIR_STATUS: Record<EmirStatus, StatusView> = {
  closed: { label: 'Kapandı', tone: 'ok' },
  inProgress: { label: 'Devam ediyor', tone: 'warn' },
  open: { label: 'Başlamadı', tone: 'info' },
  unknown: { label: 'Bilinmiyor', tone: 'neutral' },
}
